import pageUrlContext from '@rover/shared/js/eventstream/pageUrlContext';

// Cross-page events are stored on the page where the user acted and dispatched on
// the next page load. Without pinning the page-derived properties here, alooma
// stamps them live at dispatch time (`_.info.properties()` reads window.location /
// document.referrer, and withPageCategory reads window.Rover.pageCategory), which
// attributes the event to the destination page instead of the page the action
// happened on. Capturing them at store time and replaying them keeps a cross-page
// event faithful to its origin — matching what an on-page event would have recorded.
const capturePageContext = (): Record<string, unknown> => {
  if (typeof window === 'undefined') return {};

  // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
  const pageCategory = window?.Rover?.pageCategory;

  return {
    ...pageUrlContext(),
    ...(pageCategory ? { pageCategory } : {}),
  };
};

export default capturePageContext;
